import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import { EXTERNAL_LOGIN_URL } from "../../../../consts";
import { getLoggedIn } from "../../../../store/selectors";

const RedirectHome = () => {
  const loggedIn = useSelector(getLoggedIn);

  useEffect(() => {
    if (!loggedIn) {
      window.location.replace(EXTERNAL_LOGIN_URL);
    }
  }, [loggedIn]);

  if (loggedIn) {
    return <Navigate to="/home" replace />;
  }

  return null;
};

export default RedirectHome;
